var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        {
          staticClass: "white people-navbar",
          attrs: { height: "80px", flat: "", fixed: "" }
        },
        [
          _c("v-toolbar-title", [
            _c(
              "div",
              {
                class: [_vm.viewingProfile ? "active-logo" : "", "people-logo"],
                on: {
                  click: function($event) {
                    return _vm.handleClick()
                  }
                }
              },
              [
                _vm.viewingProfile
                  ? _c(
                      "v-icon",
                      { staticClass: "back-icon", attrs: { medium: "" } },
                      [_vm._v("keyboard_backspace")]
                    )
                  : _vm._e(),
                _vm._v("People")
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("v-text-field", {
            attrs: {
              "hide-details": "",
              "append-icon": "search",
              "single-line": "",
              placeholder: "Search by name or email"
            },
            on: {
              input: function($event) {
                return _vm.onInput($event)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "v-icon",
            { staticClass: "view-sheet-icon", attrs: { medium: "" } },
            [_vm._v("note")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e8e6a3ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8e6a3ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/People/PeopleNavigation.vue
// module id = BsXh
// module chunks = 1